export const PX_QUESTION_GOAL_SELECTION_NAME = 'goal-selection';
